module.exports = __webpack_public_path__ + "img/cadastro-bg.96c6ff4e.png";